<!-- Backdrop -->
@if ($visible()) {
<div
  class="bottom-sheet-backdrop"
  [class.modal]="modal"
  [style.z-index]="$backdropZIndex()"
  [@fadeAnimation]
  (click)="onBackdropClick()"
  role="presentation"
></div>

<!-- Bottom Sheet Container -->
<div
  #sheetContent
  class="bottom-sheet-container"
  [style.z-index]="$containerZIndex()"
  [class]="$sizeClass() + ' ' + $positionClass()"
  [class.dragging]="$isDragging()"
  [class.loading]="loading"
  [class.sheet-keyboard-expanded]="$isKeyboardExpanded()"
  [@slideAnimation]="position === 'bottom' ? true : undefined"
  [@slideTopAnimation]="position === 'top' ? true : undefined"
  [@.disabled]="disableAnimation"
  [ngStyle]="sheetStyles"
  role="dialog"
  [attr.aria-modal]="modal"
  [attr.aria-labelledby]="headerTemplate ? 'sheet-header' : null"
  [attr.aria-busy]="loading"
>
  <!-- Drag Handle -->
  @if ($shouldShowHandle()) {
  <div
    class="bottom-sheet-handle"
    (mousedown)="onDragStart($event)"
    (touchstart)="onDragStart($event)"
  >
    <div class="handle-bar"></div>
  </div>
  }

  <!-- Header -->
  @if (headerTemplate) {
  <div class="bottom-sheet-header" id="sheet-header">
    <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
  </div>
  }

  <!-- Content -->
  <div class="bottom-sheet-content">
    @if (loading) {
    <div class="bottom-sheet-loading">
      <div class="spinner"></div>
      <span>Carregando...</span>
    </div>
    } @else {
    <ng-content></ng-content>
    }
  </div>

  <!-- Footer -->
  @if (footerTemplate) {
  <div class="bottom-sheet-footer">
    <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
  </div>
  }
</div>
}
